<!-- Tabla de Monitores -->
<table
  mat-table
  [dataSource]="[
    {
      icon: 'dashboard',
      text: 'Dashboard',
      action: 'config',
      class: 'config_moitors'
    }
  ]"
  class="monitors-table user-table"
>
  <ng-container matColumnDef="config">
    <td mat-cell *matCellDef="let element" class="{{ element.class }}">
      <div
        class="monitor-name"
        (click)="element.action === 'config' ? onOpenDashboard() : null"
      >
        <mat-icon>{{ element.icon }}</mat-icon>
        <span class="monitor-text">{{ element.text }}</span>
      </div>
    </td>
  </ng-container>

  <tr mat-row *matRowDef="let row; columns: ['config']"></tr>
</table>

<div class="table-separator"></div>

@if (isLoading()) {
<div class="loading-spinner">
  <mat-spinner diameter="40"></mat-spinner>
  <span>Cargando monitores...</span>
</div>
}

@if (error()) {
<div class="error-message">
  <mat-icon class="error-icon">error_outline</mat-icon>
  <span>{{ error() }}</span>
  <!-- <button mat-raised-button color="primary" (click)="retryLoadMonitors()">Reintentar</button> -->
</div>
}

@if (!isLoading() && !error() && monitor().length > 0) {
<div class="monitors-container">
  <table mat-table [dataSource]="monitor()" [trackBy]="trackByMonitorId" class="monitors-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" [class.selected]="isSelected(row)">
        <div class="monitor-name">
          <button
            class="icon-button"
            [class.selected]="isSelected(row)"
            [matTooltip]="isSelected(row) ? 'Monitor seleccionado' : 'Seleccionar monitor'"
            (click)="selectMonitor(row); $event.stopPropagation()"
          >
            <mat-icon [class.selected-icon]="isSelected(row)">{{ row.riskEvaluation ? 'directions' : 'tab' }}</mat-icon>
          </button>
          <span class="monitor-text" [style.font-size]="row.riskEvaluation ? '14px' : '14px'">{{ row.name }}</span>
        </div>
      </td>
    </ng-container>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selectMonitor(row)"
      [class.selected]="isSelected(row)"
    ></tr>
  </table>
</div>
}

@if (!isLoading() && !error() && monitor().length === 0) {
<div class="no-monitors">
  <mat-icon>info</mat-icon>
  <p>No se cuenta con monitores disponibles contacte al administrador para que le asigne monitores</p>
</div>
}

<div class="table-separator"></div>

<!-- Sección de Usuarios y Configuración solo para administradores -->
@if (isAdministrator()) {
<!-- Sección de Usuarios -->
<div class="user-title">Usuarios</div>
<table
  mat-table
  [dataSource]="[{ icon: 'groups', text: 'Gestión de Usuarios' }]"
  class="monitors-table user-table"
>
  <ng-container matColumnDef="user">
    <td mat-cell *matCellDef="let element">
      <div class="monitor-name" (click)="onOpenUsersConfigClicked()">
        <mat-icon>{{ element.icon }}</mat-icon>
        <span class="monitor-text">{{ element.text }}</span>
      </div>
    </td>
  </ng-container>

  <tr mat-row *matRowDef="let row; columns: ['user']"></tr>
</table>

<div class="table-separator"></div>

<!-- Sección de Configuración -->
<div class="user-title">Configuración</div>
<table
  mat-table
  [dataSource]="configItems()"
  class="monitors-table user-table"
>
  <ng-container matColumnDef="config">
    <td mat-cell *matCellDef="let element" class="{{ element.class }}">
      <div
        class="monitor-name"
        (click)="
          element.action === 'logout'
            ? onLogoutClick()
            : element.text === 'Administración'
            ? goToAdministracion()
            : element.action === 'config'
            ? onOpenMonitorConfigClicked()
            : null
        "
      >
        <mat-icon>{{ element.icon }}</mat-icon>
        <span class="monitor-text">{{ element.text }}</span>
      </div>
    </td>
  </ng-container>

  <tr mat-row *matRowDef="let row; columns: ['config']"></tr>
</table>
}
